import { useRef, type ButtonHTMLAttributes } from 'react';

// Drawing can suppress Chromium's next synthesized click. Handle a completed
// finger tap directly, and ignore its duplicate click; mouse/keyboard keep
// the standard button behavior. A drag or cancelled touch never activates it.
export function TouchButton({ onPress, type = 'button', ...props }: Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick' | 'onPointerDown' | 'onPointerMove' | 'onPointerUp' | 'onPointerCancel'> & { onPress: () => void }) {
  const touch = useRef<{ id:number; x:number; y:number } | null>(null);
  const skipClick = useRef(false);
  return <button {...props} type={type}
    onPointerDown={event => {
      skipClick.current=false; touch.current=null;
      if(event.pointerType==='touch' && event.isPrimary && !props.disabled) {
        event.preventDefault(); event.currentTarget.focus({preventScroll:true});
        touch.current={id:event.pointerId,x:event.clientX,y:event.clientY};
      }
    }}
    onPointerMove={event => {
      const start=touch.current;
      if(start && Math.hypot(event.clientX-start.x,event.clientY-start.y)>12) { touch.current=null; skipClick.current=true; }
    }}
    onPointerCancel={()=>{touch.current=null;skipClick.current=true;}}
    onPointerUp={event => {
      if(touch.current?.id!==event.pointerId)return;
      touch.current=null;skipClick.current=true;
      if(!props.disabled)onPress();
    }}
    onClick={event=>{if(!props.disabled && (!skipClick.current || event.detail===0))onPress();}}/>
}
